// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGResizeCollapse = props => /*#__PURE__*/_jsx("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "M1.857 15h-.006.006zM6.429 9.286c.314 0 .571.257.571.571v4.572c0 .314-.257.57-.571.57-.314 0-.572-.256-.572-.57v-3.195l-3.6 3.6c-.113.114-.255.165-.402.165-.148 0-.29-.057-.403-.165-.223-.223-.223-.583 0-.806l3.6-3.6H1.858c-.315 0-.572-.257-.572-.57 0-.315.257-.572.571-.572H6.43zM9.857 1.286c.315 0 .572.257.572.571v3.194l3.594-3.594c.223-.223.583-.223.806 0 .222.223.222.583 0 .806l-3.595 3.594h3.195c.314 0 .571.257.571.571 0 .315-.257.572-.571.572H9.85h.001c-.026 0-.053-.003-.079-.007-.027-.004-.054-.01-.08-.018-.01-.002-.019-.006-.028-.01-.077-.027-.15-.07-.213-.13-.12-.12-.175-.28-.166-.437v-4.54c0-.315.257-.572.572-.572z"
  })
}));
SVGResizeCollapse.displayName = 'SVGResizeCollapse';
export default SVGResizeCollapse;